import { isAuthorizedUser } from 'shared/hooks/use-user'
import { UnauthorizedUser, UserInterface } from 'shared/types/user-interface'

/**
 * Resolves the display timezone for the current user.
 * Priority: user.timezone > browser/system timezone.
 */
export const determineTimezone = (user: UserInterface | UnauthorizedUser | undefined): string => {
  if (isAuthorizedUser(user) && user.timezone) {
    return user.timezone
  }

  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone
  } catch {
    return 'UTC'
  }
}
